'use strict';

import {initTooltips} from "./V3/Services/Tooltip.js";
import customfn from '@/_functions';
import clp from '@/_clp.js';
import customchosen from '@/components/custom-chosen.js';
import $ from 'jquery';

// Functions

$(document).on('change', 'div[data-datagrid] div[data-type="option"] select', function(event) {
    event.preventDefault();
    var $key = $(this).closest('div[data-datagrid]').data('datagrid');
    var key = $(this).attr('name');
    var value = $(this).val();
    var url = window.location.pathname + "?" + key + '=' + value;
    refreshGrid($key, url);
});

$(document).on('change', 'div[data-datagrid] select[data-type="filter"]', function(event) {
    event.preventDefault();
    var $key = $(this).closest('div[data-datagrid]').data('datagrid');
    var key = $(this).attr('name');
    var field = $(this).data('filterfield');
    var value = $(this).val();
    var url = window.location.pathname + "?" + key + '=' + field + ':' + value;
    refreshGrid($key, url);
});

$(document).on('click', '.reset-search', function(ev){
   $(this).prev('input[type="search"]').val('');
   $(document).trigger($(this).closest('form').submit());
});

$(document).on('submit', 'form.js-grid-search-form', function(event) {
    event.preventDefault();
    const $key = $(this).closest('div[data-datagrid]').data('datagrid'),
        key = $(this).data('key'),
        field = $(this).data('field'),
        valueField = $(this).data('value-field'),
        value = $(this).find(valueField).val();

    let url = $(this).closest('.systemlogs-datagrid').data('eventsurl');;

    if(typeof url !== 'undefined'){
        url = url + '?' + key + '=' + field + ':' + value;
    }

    refreshGrid($key, url);
});

$(document).on('click', 'div[data-datagrid] div[data-type="filter"] .dropdown-menu a', function(event) {
    event.preventDefault();
    var $key = $(this).closest('div[data-datagrid]').data('datagrid');
    var key = $(this).closest('.dropdown').find('button').attr('id');
    var field = $(this).closest('.dropdown').find('button').data('filterfield');
    var filterUrl = $(this).closest('.dropdown').find('button').data('url');
    var value = $(this).data('value');

    var icon = $(this).closest('.dropdown').find('button').find('span');
    var newHtml = $(this).html();
    if(icon) {
        newHtml += icon.outerHTML();
    }
    $(this).closest('.dropdown').find('button').html(newHtml);
    if(typeof filterUrl != 'undefined'){
        var url = filterUrl + "?" + key + '=' + field + ':' + value;
    }
    else {
        var url = window.location.pathname + "?" + key + '=' + field + ':' + value;
    }
    refreshGrid($key, url);
});

$(document).on('submit', 'div[data-datagrid] div[data-type="filters"] form', function(event) {
    event.preventDefault();
    var $key = $(this).closest('div[data-datagrid]').data('datagrid');
    var data = $(this).serializeArray();
    var search = $(this).find('.sb-search-input');
    var url = window.location.pathname+'?'+search.attr('name')+'='+search.val();
    refreshGrid($key, url, data);
});

$(document).on('click', 'div[data-datagrid] div[data-type="filters"] form button[name*="reset_"]', function(event) {
    event.preventDefault();
    var url = window.location.pathname;
    var $key = $(this).closest('div[data-datagrid]').data('datagrid');
    var data = {};
    data['reset_' + $key] = true;
    refreshGrid($key, url, data, true);
});

$("body").on("click", 'div[data-datagrid] table .sortable', function(event){
    event.preventDefault();
    var $key = $(this).closest('div[data-datagrid]').data('datagrid');
    var url = $(this).find('a').attr('href');
    refreshGrid($key, url);
    return false;
});

$(document).on("change", 'div[data-datagrid] div[data-type="sortby"] select', function(event) {
    event.preventDefault();
    var $key = $(this).closest('div[data-datagrid]').data('datagrid');
    var url = $(this).val();
    refreshGrid($key, url);
});


$("body").on("click", 'div[data-datagrid] div[data-type="pagination"] a ', function(event){
    event.preventDefault();
    var $key = $(this).closest('div[data-datagrid]').data('datagrid');
    var url = $(this).attr('href');

    refreshGrid($key, url);
    return false;
});

// Prevent urls from being requested to many times.
// Somehow some events are bound multiple times creating an event bubble
// causing x^2 behaviour on some events such as reset-form actions.
// By keeping track of which url is being processed we prevent the same url from being called multiple times.
// We attach the datagrid md5 to the url to make a distinction of urls and data grids just
// in case we have datagrids trying to get the information from the same url as another event.
let refreshing = [];

export function refreshGrid($key, url, data, reset){
    let refreshTrackingKey = `${$key}${url}`;

    if (refreshing.indexOf(refreshTrackingKey) > -1) {
        return false;
    }

    refreshing.push(refreshTrackingKey);

    var windowLocation = window.location.href;
    var checkKey = 'j';
    var checkValue = Math.random();
    windowLocation = updateQueryStringParameter(windowLocation, checkKey, checkValue);
    history.pushState(null, null, windowLocation);

    if(data === undefined){
        data = {};
    }

    if(reset === undefined){
        reset = false;
    }

    $.ajax({
        url: url,
        type: "get",
        data: data,
        success: function(response) {
            if(reset){
                $(document).find('div[data-datagrid="'+$key+'"] div[data-type="filters"] form input[name="search_'+$key+'}}"]').val('');
                $(document).find('div[data-datagrid="'+$key+'"] select[data-type="filter"]').val('');
                $(document).find('div[data-datagrid="'+$key+'"]').find('#refresh-events').each(function() {
                    customfn.resetButtonLoadingState(this);
                });
                $(document).find('div[data-datagrid="'+$key+'"]').find('#refresh-warnings').each(function() {
                    customfn.resetButtonLoadingState(this);
                });
            }

            $(document).find('div[data-datagrid="'+$key+'"] div[data-type="grid"] thead').replaceWith(response.columns);
            $(document).find('div[data-datagrid="'+$key+'"] div[data-type="grid"] tbody').replaceWith(response.grid);
            $(document).find('div[data-datagrid="'+$key+'"] div[data-type="pagination"]').html(response.pagination);

            setTimeout(function(){
                clp.refreshHardware($(document));
            }, 500);

            customchosen.chosen($("select.chosen-select"));

            refreshing = refreshing.filter((el) => {
                return el !== refreshTrackingKey;
            });

            const tooltipTriggerList = Array.from(document.querySelectorAll('div[data-datagrid="'+$key+'"] [data-bs-toggle="tooltip"]'));
            initTooltips(tooltipTriggerList);

            // make sure toggle switches get reloaded when interacting with centres grid
            const re = /\/centres\?(search|amount|page|sort|filter)/gi;
            if (url.match(re)) {
                window.location.reload();
            }
        },
        statusCode: {
            400: function (response) {
                if (undefined !== response.responseJSON.message) {
                    $(document).find('div[data-datagrid="'+$key+'"] div[data-type="grid"] tbody').replaceWith(
                        `<tbody><tr><td colspan="5">${response.responseJSON.message}</td></tr></tbody>`
                    );
                }
            }
        }
    })
    .fail(function(){
       // window.location.reload();
    });
}

export function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
        return uri + separator + key + "=" + value;
    }
}

const datagrid = {
    version: '1.0.0',
    refreshGrid,
    updateQueryStringParameter
};

export default datagrid;
